import React, { CSSProperties } from 'react'
import _ from 'lodash';
import {MenuItem} from './menuItem';
import { Event } from '../.././models/event';
import Timeline from '../timeline/index'

export interface Item {
    text: string,
    selected: boolean,
}

interface Props {
    items?: Item[],
    className?: string | undefined
    onItemSelected(ix:number) : void,
    statusHistory?: Event[],
    hideNotes?: boolean,
    darkModeEnabled?: boolean
}

const style: CSSProperties = {
    position: "sticky",
    top: 20,
    left: 20,
    width: 250,
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 20px)",
    borderRightStyle: "solid",
    borderRightWidth: 1,
    borderRightColor: "#E4E4E4",
}

export const Menu: React.SFC<Props> = (props) => {
    const { items, onItemSelected, statusHistory, hideNotes, darkModeEnabled, ...rest } = props;

    return (
        <div style={style} {...rest}>
            {_.map(items || [], (i, ix) => (
                <MenuItem key={i.text} text={i.text} selected={i.selected} darkModeEnabled={darkModeEnabled} onItemSelected={() => onItemSelected(ix)} />
            ))}
            <Timeline statusHistory={statusHistory} hideNotes={hideNotes} darkModeEnabled={darkModeEnabled}/>
        </div>
    )
}